import { Button } from "$components/button/button";
import { DialogBody } from "$components/dialog/dialog-body";
import { DialogContainer } from "$components/dialog/dialog-container";
import { DialogFooter } from "$components/dialog/dialog-footer";
import { DialogHeader } from "$components/dialog/dialog-header";
import { makeStyles } from "$components/mui-styles";
import { Box, Typography } from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/Error";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme) => ({
  body: {
    overflow: "auto",
  },
  warning: {
    borderRadius: "5px",
  },
  warningBreakout: {
    color: theme.palette.info.main,
  },
  warningIcon: {
    color: theme.palette.error.main,
    height: 20,
    width: 20,
    borderRadius: 10,
    outline: `5px solid ${theme.palette.warning.main}`,
  },
}));

function DeleteInvestigationModal(props: DeleteInvestigationModalProps) {
  const { open, onClose, onSubmit, investigationName, loading } = props;
  const classes = useStyles();

  const handleSubmit = useCallback(() => {
    onSubmit();
  }, [onSubmit]);

  return (
    <DialogContainer
      open={open}
      onClose={onClose}
      data-testid="investigation-delete-modal-container"
    >
      <DialogHeader title="">
        <Box display="inline-block" mr={3}>
          <ErrorIcon className={classes.warningIcon} />
        </Box>
        <Box display="inline-block">
          <Typography variant="h4">
            <FormattedMessage
              id="investigation.deletion.title"
              defaultMessage="Delete"
            />
            {` ${investigationName}`}
            <FormattedMessage
              id="investigation.deletion.title.question"
              defaultMessage="?"
            />
          </Typography>
        </Box>
      </DialogHeader>
      <DialogBody className={classes.body}>
        <Box display="flex" flexDirection="column">
          <Box p={2} display="flex" className={classes.warningBreakout}>
            <Typography className={classes.warningBreakout}>
              <FormattedMessage
                id="investigation.deletion.warning"
                defaultMessage="Deleting this investigation will remove it from the lab techinician’s view as well. If they are still processing this investigation they won’t have a card to enter the results in."
              />
            </Typography>
          </Box>
        </Box>
      </DialogBody>
      <DialogFooter>
        <Button
          color="secondary"
          onClick={onClose}
          data-testid="investigation-delete-modal-button-cancel"
        >
          <FormattedMessage
            id="patient.consent.denyBtn"
            defaultMessage="Cancel"
          />
        </Button>
        <Button
          color="error"
          onClick={handleSubmit}
          data-testid="investigation-delete-modal-button-confirm"
          loading={loading}
        >
          <FormattedMessage
            id="investigation.deletion.confirm"
            defaultMessage="Delete"
          />
        </Button>
      </DialogFooter>
    </DialogContainer>
  );
}

interface DeleteInvestigationModalProps {
  open?: boolean;
  loading?: boolean;
  investigationName: string;
  onClose: () => void;
  onSubmit: () => void;
}

DeleteInvestigationModal.defaultProps = {
  open: false,
};

export default DeleteInvestigationModal;
